import React from "react";
import { Link } from "react-router-dom";
const mata = require("../../assets/mata_laxmi.jpg");
const LotteryCard = ({ cardData }) => {
  // console.log("cardData => ", cardData);
  const gameId = cardData?.game_id;
  const hightLightMe = ['star bazar morning', 'star bazar day', 'star bazar night', 'star morning', 'star day', 'star night', 'kalyan', 'main bazar'].includes(cardData?.game_name.toLowerCase().trim());
  const loading = <div className="flex">
    <svg
      aria-hidden="true"
      class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
    <span class="">Loading...</span>
  </div>;
  return (
    <h2 className={` relative overflow-hidden border shadow-lg rounded-xl  flex flex-col pb-5 ${hightLightMe ? 'bg-yellow-200' : 'bg-orange-100'}`}>
      <div className="h-[30px]  relative py-3 mb-3 w-full ">
        <span className="absolute  capitalize min-w-[220px] overflow-hidden block leftToRight text-2xl">
          {/* SEO Image for Satta Matka Casino */}
          <img src={mata} alt="Satta Matka Casino Results - Kalyan, Madhur, Milan, Star Bazaar, Star Bazar" style={{ display: 'none' }} />
          ! Welcome to {cardData?.game_name} !
        </span>
      </div>
      <h4 className="p-1 italic font-bold lg:text-2xl text-3xl">{cardData?.game_name}</h4>
      <h5 className="p-1 italic font-bold lg:text-3xl text-4xl flex gap-5 justify-center text-green-800">

        {!cardData?.result_open && !cardData?.result_close ? (<span>{loading}</span>
        ) : (
          <span>
            {" "}
            {cardData?.result_open || ""}
            {cardData?.result_close || ""}
          </span>
        )}
      </h5>
      <h6 className="p-1 italic font-bold lg:text-lg text-2xl">
        <span>{cardData?.game_from_time} </span>
        <span> to </span>
        <span>{cardData?.game_to_time} </span>
      </h6>
      <div className="absolute grid place-items-center bottom-6 left-6  text-xl bg-blue-800 text-white rounded-tl-md rounded-br-md  px-4 py-1">
        <Link to={`/jodiChart/${gameId}`}>Jodi</Link>
      </div>
      <div className="absolute grid place-items-center bottom-6 right-6 text-xl bg-blue-800 text-white rounded-tl-md rounded-br-md px-4 py-1 ">
        <Link to={`/panelChart/${gameId}`}>Panel</Link>
      </div>
    </h2>
  );
};

export default LotteryCard;
